import registry from './publication-map.json';
export interface PublicationMapping { questionId: string; proposalId: string; revision: number; licenseEndsAt: string | null; assetFiles: string[]; questionSha256: string }
export const publicationMappings = registry.materials as PublicationMapping[];
